/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { AutoMatchClassLinkParams } from '../_model/autoMatchClassLinkParams';
import type { GetMyClassroomsParams } from '../_model/getMyClassroomsParams';
import type { JoinClassReq } from '../_model/joinClassReq';
import type { SuccessBody } from '../_model/successBody';
import type { SuccessBodyAutoMatchRes } from '../_model/successBodyAutoMatchRes';
import type { SuccessBodyClassMemberRes } from '../_model/successBodyClassMemberRes';
import type { SuccessBodyJoinClassRes } from '../_model/successBodyJoinClassRes';
import type { SuccessBodyListClassMaterialRes } from '../_model/successBodyListClassMaterialRes';
import type { SuccessBodyListMyClassLinkHistoryRes } from '../_model/successBodyListMyClassLinkHistoryRes';
import type { SuccessBodyListMyClassroomRes } from '../_model/successBodyListMyClassroomRes';
import type { SuccessBodyMyClassroomDetailRes } from '../_model/successBodyMyClassroomDetailRes';
import type { SuccessBodyVerifyClassCodeRes } from '../_model/successBodyVerifyClassCodeRes';
import type { UpdateMyDisplayNameReq } from '../_model/updateMyDisplayNameReq';
import type { VerifyClassCodeReq } from '../_model/verifyClassCodeReq';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const recordMaterialRead = (
  classGroupId: string,
  classMaterialId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBody>(
    {
      url: `/my-classrooms/${classGroupId}/materials/${classMaterialId}/read`,
      method: 'POST',
      signal,
    },
    options,
  );
};

export const getRecordMaterialReadMutationKey = () =>
  ['recordMaterialRead'] as const;

export const getRecordMaterialReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordMaterialRead>>,
    TError,
    RecordMaterialReadMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordMaterialRead>>,
  TError,
  RecordMaterialReadMutationVariables,
  TContext
> => {
  const mutationKey = getRecordMaterialReadMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordMaterialRead>>,
    RecordMaterialReadMutationVariables
  > = props => {
    const { classGroupId, classMaterialId } = props ?? {};

    return recordMaterialRead(classGroupId, classMaterialId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordMaterialReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordMaterialRead>>
>;

export type RecordMaterialReadMutationError = ErrorType<unknown>;
export type RecordMaterialReadMutationVariables = {
  classGroupId: string;
  classMaterialId: string;
};

export const useRecordMaterialRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof recordMaterialRead>>,
      TError,
      RecordMaterialReadMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof recordMaterialRead>>,
  TError,
  RecordMaterialReadMutationVariables,
  TContext
> => {
  return useMutation(
    getRecordMaterialReadMutationOptions(options),
    queryClient,
  );
};
export const joinClass = (
  classGroupId: string,
  joinClassReq: BodyType<JoinClassReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyJoinClassRes>(
    {
      url: `/classrooms/${classGroupId}/join`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: joinClassReq,
      signal,
    },
    options,
  );
};

export const getJoinClassMutationKey = () => ['joinClass'] as const;

export const getJoinClassMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof joinClass>>,
    TError,
    JoinClassMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof joinClass>>,
  TError,
  JoinClassMutationVariables,
  TContext
> => {
  const mutationKey = getJoinClassMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof joinClass>>,
    JoinClassMutationVariables
  > = props => {
    const { classGroupId, data } = props ?? {};

    return joinClass(classGroupId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type JoinClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof joinClass>>
>;
export type JoinClassMutationBody = BodyType<JoinClassReq>;
export type JoinClassMutationError = ErrorType<unknown>;
export type JoinClassMutationVariables = {
  classGroupId: string;
  data: BodyType<JoinClassReq>;
};

export const useJoinClass = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof joinClass>>,
      TError,
      JoinClassMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof joinClass>>,
  TError,
  JoinClassMutationVariables,
  TContext
> => {
  return useMutation(getJoinClassMutationOptions(options), queryClient);
};
export const verifyClassCode = (
  verifyClassCodeReq: BodyType<VerifyClassCodeReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyVerifyClassCodeRes>(
    {
      url: `/classrooms/verify-code`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: verifyClassCodeReq,
      signal,
    },
    options,
  );
};

export const getVerifyClassCodeMutationKey = () => ['verifyClassCode'] as const;

export const getVerifyClassCodeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyClassCode>>,
    TError,
    VerifyClassCodeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyClassCode>>,
  TError,
  VerifyClassCodeMutationVariables,
  TContext
> => {
  const mutationKey = getVerifyClassCodeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyClassCode>>,
    VerifyClassCodeMutationVariables
  > = props => {
    const { data } = props ?? {};

    return verifyClassCode(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyClassCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyClassCode>>
>;
export type VerifyClassCodeMutationBody = BodyType<VerifyClassCodeReq>;
export type VerifyClassCodeMutationError = ErrorType<unknown>;
export type VerifyClassCodeMutationVariables = {
  data: BodyType<VerifyClassCodeReq>;
};

export const useVerifyClassCode = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verifyClassCode>>,
      TError,
      VerifyClassCodeMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verifyClassCode>>,
  TError,
  VerifyClassCodeMutationVariables,
  TContext
> => {
  return useMutation(getVerifyClassCodeMutationOptions(options), queryClient);
};
export const updateMyDisplayName = (
  classGroupId: string,
  updateMyDisplayNameReq: BodyType<UpdateMyDisplayNameReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyClassMemberRes>(
    {
      url: `/classrooms/${classGroupId}/members/me/display-name`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateMyDisplayNameReq,
      signal,
    },
    options,
  );
};

export const getUpdateMyDisplayNameMutationKey = () =>
  ['updateMyDisplayName'] as const;

export const getUpdateMyDisplayNameMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyDisplayName>>,
    TError,
    UpdateMyDisplayNameMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyDisplayName>>,
  TError,
  UpdateMyDisplayNameMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateMyDisplayNameMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyDisplayName>>,
    UpdateMyDisplayNameMutationVariables
  > = props => {
    const { classGroupId, data } = props ?? {};

    return updateMyDisplayName(classGroupId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyDisplayNameMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyDisplayName>>
>;
export type UpdateMyDisplayNameMutationBody = BodyType<UpdateMyDisplayNameReq>;
export type UpdateMyDisplayNameMutationError = ErrorType<unknown>;
export type UpdateMyDisplayNameMutationVariables = {
  classGroupId: string;
  data: BodyType<UpdateMyDisplayNameReq>;
};

export const useUpdateMyDisplayName = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMyDisplayName>>,
      TError,
      UpdateMyDisplayNameMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMyDisplayName>>,
  TError,
  UpdateMyDisplayNameMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateMyDisplayNameMutationOptions(options),
    queryClient,
  );
};
/**
 * @deprecated
 */
export const getMyClassrooms = (
  params?: GetMyClassroomsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListMyClassroomRes>(
    { url: `/my-classrooms`, method: 'GET', params, signal },
    options,
  );
};

export const getGetMyClassroomsQueryKey = (params?: GetMyClassroomsParams) => {
  return [`/my-classrooms`, ...(params ? [params] : [])] as const;
};

export const getGetMyClassroomsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyClassroomsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyClassrooms>>> = ({
    signal,
  }) => getMyClassrooms(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyClassrooms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyClassroomsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyClassrooms>>
>;
export type GetMyClassroomsQueryError = ErrorType<unknown>;

export function useGetMyClassrooms<
  TData = Awaited<ReturnType<typeof getMyClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetMyClassroomsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassrooms>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassrooms>>,
          TError,
          Awaited<ReturnType<typeof getMyClassrooms>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyClassrooms<
  TData = Awaited<ReturnType<typeof getMyClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassrooms>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassrooms>>,
          TError,
          Awaited<ReturnType<typeof getMyClassrooms>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyClassrooms<
  TData = Awaited<ReturnType<typeof getMyClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @deprecated
 */

export function useGetMyClassrooms<
  TData = Awaited<ReturnType<typeof getMyClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyClassroomsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetMyClassroomsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyClassroomsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyClassroomsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyClassrooms>>> = ({
    signal,
  }) => getMyClassrooms(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMyClassrooms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetMyClassroomsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyClassrooms>>
>;
export type GetMyClassroomsSuspenseQueryError = ErrorType<unknown>;

export function useGetMyClassroomsSuspense<
  TData = Awaited<ReturnType<typeof getMyClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetMyClassroomsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyClassroomsSuspense<
  TData = Awaited<ReturnType<typeof getMyClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyClassroomsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyClassroomsSuspense<
  TData = Awaited<ReturnType<typeof getMyClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyClassroomsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @deprecated
 */

export function useGetMyClassroomsSuspense<
  TData = Awaited<ReturnType<typeof getMyClassrooms>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyClassroomsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassrooms>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyClassroomsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getMyClassroomDetail = (
  classGroupId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyMyClassroomDetailRes>(
    { url: `/my-classrooms/${classGroupId}`, method: 'GET', signal },
    options,
  );
};

export const getGetMyClassroomDetailQueryKey = (classGroupId: string) => {
  return [`/my-classrooms/${classGroupId}`] as const;
};

export const getGetMyClassroomDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyClassroomDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyClassroomDetailQueryKey(classGroupId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyClassroomDetail>>
  > = ({ signal }) =>
    getMyClassroomDetail(classGroupId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: classGroupId !== null && classGroupId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyClassroomDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyClassroomDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyClassroomDetail>>
>;
export type GetMyClassroomDetailQueryError = ErrorType<unknown>;

export function useGetMyClassroomDetail<
  TData = Awaited<ReturnType<typeof getMyClassroomDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassroomDetail>>,
          TError,
          Awaited<ReturnType<typeof getMyClassroomDetail>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyClassroomDetail<
  TData = Awaited<ReturnType<typeof getMyClassroomDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassroomDetail>>,
          TError,
          Awaited<ReturnType<typeof getMyClassroomDetail>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyClassroomDetail<
  TData = Awaited<ReturnType<typeof getMyClassroomDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetMyClassroomDetail<
  TData = Awaited<ReturnType<typeof getMyClassroomDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyClassroomDetailQueryOptions(
    classGroupId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetMyClassroomDetailSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyClassroomDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyClassroomDetailQueryKey(classGroupId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyClassroomDetail>>
  > = ({ signal }) =>
    getMyClassroomDetail(classGroupId, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMyClassroomDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetMyClassroomDetailSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyClassroomDetail>>
>;
export type GetMyClassroomDetailSuspenseQueryError = ErrorType<unknown>;

export function useGetMyClassroomDetailSuspense<
  TData = Awaited<ReturnType<typeof getMyClassroomDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyClassroomDetailSuspense<
  TData = Awaited<ReturnType<typeof getMyClassroomDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyClassroomDetailSuspense<
  TData = Awaited<ReturnType<typeof getMyClassroomDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetMyClassroomDetailSuspense<
  TData = Awaited<ReturnType<typeof getMyClassroomDetail>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyClassroomDetailSuspenseQueryOptions(
    classGroupId,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * 학생이 본인을 학급에서 탈퇴 처리
 */
export const leaveClassroom = (
  classGroupId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBody>(
    { url: `/my-classrooms/${classGroupId}`, method: 'DELETE', signal },
    options,
  );
};

export const getLeaveClassroomMutationKey = () => ['leaveClassroom'] as const;

export const getLeaveClassroomMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof leaveClassroom>>,
    TError,
    LeaveClassroomMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof leaveClassroom>>,
  TError,
  LeaveClassroomMutationVariables,
  TContext
> => {
  const mutationKey = getLeaveClassroomMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof leaveClassroom>>,
    LeaveClassroomMutationVariables
  > = props => {
    const { classGroupId } = props ?? {};

    return leaveClassroom(classGroupId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LeaveClassroomMutationResult = NonNullable<
  Awaited<ReturnType<typeof leaveClassroom>>
>;

export type LeaveClassroomMutationError = ErrorType<unknown>;
export type LeaveClassroomMutationVariables = { classGroupId: string };

export const useLeaveClassroom = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof leaveClassroom>>,
      TError,
      LeaveClassroomMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof leaveClassroom>>,
  TError,
  LeaveClassroomMutationVariables,
  TContext
> => {
  return useMutation(getLeaveClassroomMutationOptions(options), queryClient);
};
export const getMyClassroomHistories = (
  classGroupId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListMyClassLinkHistoryRes>(
    {
      url: `/my-classrooms/${classGroupId}/my-histories`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetMyClassroomHistoriesQueryKey = (classGroupId: string) => {
  return [`/my-classrooms/${classGroupId}/my-histories`] as const;
};

export const getGetMyClassroomHistoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyClassroomHistories>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomHistories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyClassroomHistoriesQueryKey(classGroupId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyClassroomHistories>>
  > = ({ signal }) =>
    getMyClassroomHistories(classGroupId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: classGroupId !== null && classGroupId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyClassroomHistories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyClassroomHistoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyClassroomHistories>>
>;
export type GetMyClassroomHistoriesQueryError = ErrorType<unknown>;

export function useGetMyClassroomHistories<
  TData = Awaited<ReturnType<typeof getMyClassroomHistories>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomHistories>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassroomHistories>>,
          TError,
          Awaited<ReturnType<typeof getMyClassroomHistories>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyClassroomHistories<
  TData = Awaited<ReturnType<typeof getMyClassroomHistories>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomHistories>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassroomHistories>>,
          TError,
          Awaited<ReturnType<typeof getMyClassroomHistories>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyClassroomHistories<
  TData = Awaited<ReturnType<typeof getMyClassroomHistories>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomHistories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetMyClassroomHistories<
  TData = Awaited<ReturnType<typeof getMyClassroomHistories>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomHistories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyClassroomHistoriesQueryOptions(
    classGroupId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetMyClassroomHistoriesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyClassroomHistories>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomHistories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyClassroomHistoriesQueryKey(classGroupId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyClassroomHistories>>
  > = ({ signal }) =>
    getMyClassroomHistories(classGroupId, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMyClassroomHistories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetMyClassroomHistoriesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyClassroomHistories>>
>;
export type GetMyClassroomHistoriesSuspenseQueryError = ErrorType<unknown>;

export function useGetMyClassroomHistoriesSuspense<
  TData = Awaited<ReturnType<typeof getMyClassroomHistories>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomHistories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyClassroomHistoriesSuspense<
  TData = Awaited<ReturnType<typeof getMyClassroomHistories>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomHistories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyClassroomHistoriesSuspense<
  TData = Awaited<ReturnType<typeof getMyClassroomHistories>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomHistories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetMyClassroomHistoriesSuspense<
  TData = Awaited<ReturnType<typeof getMyClassroomHistories>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomHistories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyClassroomHistoriesSuspenseQueryOptions(
    classGroupId,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getMyClassroomMaterials = (
  classGroupId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListClassMaterialRes>(
    { url: `/my-classrooms/${classGroupId}/materials`, method: 'GET', signal },
    options,
  );
};

export const getGetMyClassroomMaterialsQueryKey = (classGroupId: string) => {
  return [`/my-classrooms/${classGroupId}/materials`] as const;
};

export const getGetMyClassroomMaterialsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyClassroomMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomMaterials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyClassroomMaterialsQueryKey(classGroupId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyClassroomMaterials>>
  > = ({ signal }) =>
    getMyClassroomMaterials(classGroupId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: classGroupId !== null && classGroupId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyClassroomMaterials>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyClassroomMaterialsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyClassroomMaterials>>
>;
export type GetMyClassroomMaterialsQueryError = ErrorType<unknown>;

export function useGetMyClassroomMaterials<
  TData = Awaited<ReturnType<typeof getMyClassroomMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomMaterials>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassroomMaterials>>,
          TError,
          Awaited<ReturnType<typeof getMyClassroomMaterials>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyClassroomMaterials<
  TData = Awaited<ReturnType<typeof getMyClassroomMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomMaterials>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassroomMaterials>>,
          TError,
          Awaited<ReturnType<typeof getMyClassroomMaterials>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyClassroomMaterials<
  TData = Awaited<ReturnType<typeof getMyClassroomMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomMaterials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetMyClassroomMaterials<
  TData = Awaited<ReturnType<typeof getMyClassroomMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomMaterials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyClassroomMaterialsQueryOptions(
    classGroupId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetMyClassroomMaterialsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyClassroomMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomMaterials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyClassroomMaterialsQueryKey(classGroupId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyClassroomMaterials>>
  > = ({ signal }) =>
    getMyClassroomMaterials(classGroupId, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMyClassroomMaterials>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetMyClassroomMaterialsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyClassroomMaterials>>
>;
export type GetMyClassroomMaterialsSuspenseQueryError = ErrorType<unknown>;

export function useGetMyClassroomMaterialsSuspense<
  TData = Awaited<ReturnType<typeof getMyClassroomMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomMaterials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyClassroomMaterialsSuspense<
  TData = Awaited<ReturnType<typeof getMyClassroomMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomMaterials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyClassroomMaterialsSuspense<
  TData = Awaited<ReturnType<typeof getMyClassroomMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomMaterials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetMyClassroomMaterialsSuspense<
  TData = Awaited<ReturnType<typeof getMyClassroomMaterials>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyClassroomMaterials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyClassroomMaterialsSuspenseQueryOptions(
    classGroupId,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const autoMatchClassLink = (
  params: AutoMatchClassLinkParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyAutoMatchRes>(
    { url: `/class-links/auto-match`, method: 'GET', params, signal },
    options,
  );
};

export const getAutoMatchClassLinkQueryKey = (
  params?: AutoMatchClassLinkParams,
) => {
  return [`/class-links/auto-match`, ...(params ? [params] : [])] as const;
};

export const getAutoMatchClassLinkQueryOptions = <
  TData = Awaited<ReturnType<typeof autoMatchClassLink>>,
  TError = ErrorType<unknown>,
>(
  params: AutoMatchClassLinkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof autoMatchClassLink>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAutoMatchClassLinkQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof autoMatchClassLink>>
  > = ({ signal }) => autoMatchClassLink(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof autoMatchClassLink>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutoMatchClassLinkQueryResult = NonNullable<
  Awaited<ReturnType<typeof autoMatchClassLink>>
>;
export type AutoMatchClassLinkQueryError = ErrorType<unknown>;

export function useAutoMatchClassLink<
  TData = Awaited<ReturnType<typeof autoMatchClassLink>>,
  TError = ErrorType<unknown>,
>(
  params: AutoMatchClassLinkParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof autoMatchClassLink>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof autoMatchClassLink>>,
          TError,
          Awaited<ReturnType<typeof autoMatchClassLink>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutoMatchClassLink<
  TData = Awaited<ReturnType<typeof autoMatchClassLink>>,
  TError = ErrorType<unknown>,
>(
  params: AutoMatchClassLinkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof autoMatchClassLink>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof autoMatchClassLink>>,
          TError,
          Awaited<ReturnType<typeof autoMatchClassLink>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutoMatchClassLink<
  TData = Awaited<ReturnType<typeof autoMatchClassLink>>,
  TError = ErrorType<unknown>,
>(
  params: AutoMatchClassLinkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof autoMatchClassLink>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useAutoMatchClassLink<
  TData = Awaited<ReturnType<typeof autoMatchClassLink>>,
  TError = ErrorType<unknown>,
>(
  params: AutoMatchClassLinkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof autoMatchClassLink>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutoMatchClassLinkQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getAutoMatchClassLinkSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof autoMatchClassLink>>,
  TError = ErrorType<unknown>,
>(
  params: AutoMatchClassLinkParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof autoMatchClassLink>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAutoMatchClassLinkQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof autoMatchClassLink>>
  > = ({ signal }) => autoMatchClassLink(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof autoMatchClassLink>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type AutoMatchClassLinkSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof autoMatchClassLink>>
>;
export type AutoMatchClassLinkSuspenseQueryError = ErrorType<unknown>;

export function useAutoMatchClassLinkSuspense<
  TData = Awaited<ReturnType<typeof autoMatchClassLink>>,
  TError = ErrorType<unknown>,
>(
  params: AutoMatchClassLinkParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof autoMatchClassLink>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutoMatchClassLinkSuspense<
  TData = Awaited<ReturnType<typeof autoMatchClassLink>>,
  TError = ErrorType<unknown>,
>(
  params: AutoMatchClassLinkParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof autoMatchClassLink>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutoMatchClassLinkSuspense<
  TData = Awaited<ReturnType<typeof autoMatchClassLink>>,
  TError = ErrorType<unknown>,
>(
  params: AutoMatchClassLinkParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof autoMatchClassLink>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useAutoMatchClassLinkSuspense<
  TData = Awaited<ReturnType<typeof autoMatchClassLink>>,
  TError = ErrorType<unknown>,
>(
  params: AutoMatchClassLinkParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof autoMatchClassLink>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutoMatchClassLinkSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
